import PropTypes from 'prop-types';

import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import ArrowForwardIcon from '../images/hx_arrow-narrow-right-filled.svg';

const StyledTitle = styled.p`
    text-decoration: none;
    font-size: 14px;
    line-height: 16.59px;
    font-weight: ${({ isMenuOpen }) => (isMenuOpen ? '500' : '400')};
    text-align: center;
    color: ${({ isMenuOpen }) => (isMenuOpen ? '#212121' : '#262626')};
    padding: 24px 5px 24px 24px;
`;

const StyledDropdown = styled.div`
    width: 100%;
`;

const StyledDropdownHeadingWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const StyledExpandMoreIcon = styled(ExpandMore)`
    color: #262626;
    font-size: 24px;
`;

const StyledExpandLessIcon = styled(ExpandLess)`
    color: #262626;
    font-size: 24px;
`;

const ArrowIcon = styled.img`
    display: none;
    width: 16px;
    height: 16px;
    color: #262626;
    position: absolute;
    top: 12px;
    right: 12px;
`;

const StyledSubMenu = styled.div`
    max-width: 320px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    background-color: #fff;
    padding: 12px;
    margin-top: -8px;
    margin-bottom: 16px;
    margin-left: 24px;
    border: 1px solid #eff0f6;
    border-radius: 8px;
    gap: 6px;
`;

const SubLinkIcon = styled.img`
    width: 24px;
    height: 24px;
    padding: 4px;
    border-radius: 5px;
    background-color: #fff;
`;

const SubLinkTitle = styled.h4`
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #262626;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const StyledSubMenuItem = styled(Link)`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    gap: 4px;
    padding: 8px;

    &:hover {
        width: 100%;
        background: #e3eeff;
        border-radius: 8px;
    }

    &:hover ${SubLinkTitle} {
        font-weight: 500;
    }

    &:hover ${ArrowIcon} {
        display: block;
    }
`;

const ResponsiveSubMenu = ({ isMenuOpen, title, toggleMenu, menuItems }) => {
    return (
        <StyledDropdown>
            <StyledDropdownHeadingWrapper onClick={toggleMenu}>
                <StyledTitle isMenuOpen={isMenuOpen}>{title}</StyledTitle>
                {isMenuOpen ? <StyledExpandLessIcon /> : <StyledExpandMoreIcon />}
            </StyledDropdownHeadingWrapper>
            {isMenuOpen && (
                <StyledSubMenu>
                    {menuItems.map((item) => (
                        <StyledSubMenuItem key={item.id} to={item.link.route} {...item.link}>
                            <SubLinkIcon src={item.icon} alt={item.title} />
                            <SubLinkTitle>{item.title}</SubLinkTitle>
                            <ArrowIcon src={ArrowForwardIcon} alt="Arrow icon" />
                        </StyledSubMenuItem>
                    ))}
                </StyledSubMenu>
            )}
        </StyledDropdown>
    );
};

ResponsiveSubMenu.propTypes = {
    isMenuOpen: PropTypes.bool,
    title: PropTypes.string,
    toggleMenu: PropTypes.func,
    menuItems: PropTypes.array,
};

export default ResponsiveSubMenu;
